import CreateCharacterPage from './CreateCharacterPage';

export default CreateCharacterPage;
